import React, { forwardRef, Ref, useMemo } from 'react';

import useTheme from '@gojob/ui-bits/styles/useTheme';
import Text, { TextProps } from '@gojob/ui-bits/Text';

export interface TagProps extends Omit<TextProps<'span'>, 'ref'> {}

const useStyles = () => {
  const { spacing, colors } = useTheme();
  return useMemo(() => {
    return {
      root: {
        margin: spacing(1),
        fontSize: spacing(2),
        color: colors.indigo,
        backgroundColor: colors.pattensBlue,
        borderRadius: spacing(2),
        padding: spacing(0, 1),
      },
    } as const;
  }, [spacing, colors]);
};

const Tag = (props: TagProps, ref: Ref<HTMLSpanElement>) => {
  const classes = useStyles();

  return <Text<'span'> ref={ref} css={classes.root} {...props} />;
};

export default forwardRef(Tag);
